export default __webpack_public_path__ + "static/media/ChronicleSSm-Bold_Web.891b6ec0.woff";